import Vue from 'vue';
import Router from 'vue-router';

import HomeRoutes from './routes/home';
import LoginRoutes from './routes/login';
import ReportRoutes from './routes/reports';
import UserRoutes from './routes/users';

import AllowAnonymousGuard from './guards/allowAnonymous';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...HomeRoutes,
    ...LoginRoutes,
    ...ReportRoutes,
    ...UserRoutes,
  ],
});

AllowAnonymousGuard(router);

export default router;
